<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="person-search">
      <a-form layout="inline">
        <a-form-item class="name" label="人员名字或者账号">
          <a-input
            class="form-cell"
            type="text"
            v-model="queryParam.keyword"
          ></a-input>
        </a-form-item>
        <a-form-item label="角色">
          <a-select
            class="form-cell"
            placeholder="请选择"
            v-model="queryParam.roleId"
          >
            <a-select-option
              v-for="(item, index) in roleList"
              :key="index"
              :value="item.id"
              >{{ item.roleName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchPerson()">查询</a-button>
          <a-button type="primary" @click="() => (queryParam = {})"
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <div class="person-oper">
      <a-button type="primary" icon="plus" @click="$refs.personForm.init('add')"
        >新建</a-button
      >
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :loading="loading"
      class="c-table"
      :rowKey="getRowKey"
      @change="tableChange"
    >
      <span slot="accRole" slot-scope="text">
        <template>
          <span>{{ text ? text.roleName : '' }}</span>
        </template>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="isDisablePerson(record)">{{
            record.status == 0 ? '禁用' : '解禁'
          }}</a>
          <a-divider type="vertical" />
          <a @click="$refs.personPassword.init(record)">重置密码</a>
          <a-divider type="vertical" />
          <a @click="$refs.personForm.init('update', record)">修改</a>
          <a-divider type="vertical" />
          <a @click="deletePerson(record)">删除</a>
        </template>
      </span>
    </a-table>
    <person-form-modal
      ref="personForm"
      @addPerson="addPerson"
    ></person-form-modal>

    <person-password-modal ref="personPassword"></person-password-modal>
  </div>
</template>
<script>
import CTable from '../../components/CTable'

import person from '../../api/person'

import PersonFormModal from './PersonFormModal'

import PersonPasswordModal from './PersonPasswordModal'

import { analysisAddress } from '../../utils/address'

const columns = [
  {
    title: '角色',
    dataIndex: 'accRole',
    key: 'accRole',
    scopedSlots: { customRender: 'accRole' },
  },
  {
    title: '用户名',
    dataIndex: 'username',
    key: 'username',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
    key: 'mobile',
  },
  {
    title: '姓名',
    dataIndex: 'nickname',
    key: 'nickname',
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'personList',
  data() {
    return {
      dataSource: [],
      columns,
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
      }, //分页数据对象
      queryParam: {}, //查询参数
      loading: true,
      queryParams: {}, //用于改变数据时的查询参数
      roleList: [], //角色筛选
    }
  },
  components: {
    CTable,
    PersonFormModal,
    PersonPasswordModal,
  },
  methods: {
    getRowKey(record, index) {
      return index;
    },
    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地址的话，把地址解析之后带入
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = pagination.current
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      //用于删除增加等需要的搜索条件
      this.queryParams = obj
      this.getPersonList(obj)
    },

    //新增一个学生
    addPerson(person) {
      console.log()
      this.dataSource.unshift(person)
    },

    //是否禁用人员
    isDisablePerson(value) {
      if (value.status == 0) {
        this.disablePerson(value)
      } else {
        this.enablePerson(value)
      }
    },

    //禁用人员
    disablePerson(value) {
      person.disablePerson(value.id).then((res) => {
        this.$set(value, 'status', 1)
        this.$message.success('禁用成功')
      })
    },

    //解禁人员
    enablePerson(value) {
      person.enablePerson(value.id).then((res) => {
        this.$set(value, 'status', 0)
        this.$message.success('解禁成功')
      })
    },

    //查询人员
    searchPerson() {
      this.queryParam.currentPage = 1
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        this.queryParam
      )}`
      this.getPersonList(this.queryParam)
    },

    //人员列表
    getPersonList(params) {
      this.loading = true
      person.getPersonList(params).then((res) => {
        console.log('当前的人员列表是：', res.data.list)
        this.dataSource = res.data.list
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },

    //删除人员
    deletePerson(value) {
      let self = this
      this.$confirm({
        title: '确定要删除吗?',
        okText: '确定',
        cancelText: '取消',
        content: '删除后，无法撤销',
        onOk() {
          person.deletePerson(value.id).then((res) => {
            self.$message.success('删除成功')
            self.deleteCourseData(self.dataSource, value.id)
          })
        },
      })
    },

    //删除数据
    deleteCourseData(data, id) {
      for (let i in data) {
        if (data[i].id == id) {
          data.splice(i, 1)
          break
        }
      }
    },
  },
  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
    } else {
      this.queryParam = {}
    }
    this.getPersonList(this.queryParam)
    this.roleList = JSON.parse(JSON.stringify(this.$store.state.common.code))
    this.roleList.push({
      id: 4,
      roleName: '课程方负责人',
    })
    this.roleList = this.roleList.filter((item) => {
      if (item.roleName != '代理负责人') {
        return item
      }
    })
    console.log('this.role', this.roleList)
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.person-oper {
  margin: 20px 0px 30px;
}
</style>
